import { useState, useEffect } from "react";

interface Props {
  visibility: boolean;
}
export default function Spinner(props: Props) {
  const [display, setDisplay] = useState("none");

  useEffect(() => {
    if (props.visibility) {
      setDisplay("block");
    } else {
      setDisplay("none");
    }
  }, [props.visibility]);

  return (
    <div
      style={{
        display: display,
        position: "fixed",
        width: "100vw",
        height: "100vh",
        top: 0,
        left: 0,
        overflow: "hidden",
        background: "rgba(0,0,0,0.5)",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
        }}
        className="spinner-grow"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}
